// Zes dienstkaarten op de homepage, tussen de logobalk en de informatiebanners.
// Elke kaart wijst naar een bestaande dienstpagina of naar een eigen netwerksite.
// Foto's zijn nog niet aangeleverd: vul per kaart `foto` en `alt` in zodra ze er zijn.

export type Dienstkaart = {
  titel: string;
  ondertitel: string;
  /** Interne dienst-slug uit het dienstenaanbod. */
  dienst?: string;
  /** Volledig externe adres, bijvoorbeeld een site uit het offertes-netwerk. */
  url?: string;
  /** Foto van het product; pas zichtbaar zodra die is ingevuld. */
  foto?: string;
  alt?: string;
};

export const DIENSTKAARTEN: Dienstkaart[] = [
  {
    titel: "Access points",
    ondertitel: "Overal razendsnelle wifi?",
    dienst: "databekabeling",
  },
  {
    titel: "Beveiliging",
    ondertitel: "Altijd alles haarscherp op beeld",
    dienst: "camerabeveiliging",
  },
  {
    titel: "Groepenkasten",
    ondertitel: "Groepenkast vervangen of uitbreiden",
    dienst: "groepenkast",
  },
  {
    titel: "Verlichting",
    ondertitel: "Energiezuinige LED-verlichting",
    dienst: "verlichting-aanleggen",
  },
  {
    titel: "Laadpalen",
    ondertitel: "Slim laden thuis en op het werk",
    dienst: "laadpaal-installeren",
  },
  {
    titel: "Thuisbatterij",
    ondertitel: "Leef op eigen zonnestroom",
    url: "https://thuisbatterijenoffertes.com",
  },
];
